// Lightly tint a base colour toward a target colour. Used for the immersive sky in the
// gamified questionnaire (sky tints toward the current section's colour).
//
// AI-CONTEXT: See docs/features/questionnaire-sections.md

// Parse #RGB / #RRGGBB → [r,g,b], or null if it isn't a hex colour.
export const parseHex = (hex) => {
    if (typeof hex !== 'string') return null
    let h = hex.trim().replace('#', '')
    if (h.length === 3) h = h.split('').map(c => c + c).join('')
    if (h.length !== 6 || /[^0-9a-fA-F]/.test(h)) return null
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)]
}

// Mix `baseHex` toward `tintHex` by fraction `t` (0 = base, 1 = tint). Returns an
// `rgb(...)` string, or the original `baseHex` if either colour can't be parsed.
const tintColor = (baseHex, tintHex, t) => {
    const a = parseHex(baseHex)
    const b = parseHex(tintHex)
    if (!a || !b) return baseHex
    const m = a.map((c, i) => Math.round(c + (b[i] - c) * t))
    return `rgb(${m[0]}, ${m[1]}, ${m[2]})`
}

export default tintColor
